import { useMutation }      from '@apollo/client'
import { PencilSquareIcon } from '@heroicons/react/24/outline'
import { useSelector }      from 'react-redux'
import { Link }             from 'react-router-dom'
import { CREATE_SETTINGS }  from '../../../graphql/settings'
import { Button }           from '../../'

export default function SettingsGeneralTab(): JSX.Element {
  const currentUser: any = useSelector( ( state: any ): any => state.currentUser.user )

  const [ createSettings, { loading: creatingSettings } ] = useMutation( CREATE_SETTINGS, {
    variables:   { input: { name: 'NewSettings', handle: 'new-settings', config: {} } },
    onCompleted: (): void => window.location.reload()
  } )

  return (
    <div className="flex flex-col space-y-4 w-full">
      <div className="flex items-center justify-between w-full">
        <div>Dashboard Banner</div>
        <Link to={ `/settings/dashboard/banner` }>
          <button className="flex items-center text-sm text-blue-input font-medium px-3 py-1 bg-yellow-300 rounded-full">
            <PencilSquareIcon className="w-4 h-4" />
            <span className="pl-1 text-left">Edit</span>
          </button>
        </Link>
      </div>

      { currentUser?.email === 'dawid@denfield.co.uk' &&
        <div className="flex items-center justify-between w-full">
          <div className="flex justify-end w-full my-4">
            <div className="flex">
              <Button label="Create Config" onClick={ (): any => createSettings() } disabled={ creatingSettings } />
            </div>
          </div>
        </div>
      }
    </div>
  )
}
